import React, {useState, useEffect} from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CONTRATO_MENSUAL, CONTRATO_TRIMESTAL, CONTRATO_SEMESTRAL, CONTRATO_ANUAL, SERVICE_DROPCONTROL_FREE, SERVICE_DROPCONTROL_DROPCONTROL, SERVICE_DROPCONTROL_LITE, SERVICE_DROPCONTROL_PREMIUM, SERVICE_DROPCONTROL, SERVICE_ADDITIONAL_API, SERVICE_ADDITIONAL_USER } from "../../utils/BillingUtils";

import withName from "../../hoc/withName";
import DataTablePrime from "../PrimeComponents/DataTablePrime";
const BillingParamsPanel = ({billingInfo}) => {

    const { t, i18n } = useTranslation();
    const [nodes, setNodes] = useState(null);
    const [priceList,setPriceList] = useState(null);
    const serviceLevels = [
        {"label":t("billing.serviceLevels.0"), "id":SERVICE_DROPCONTROL_FREE},
        {"label":t("billing.serviceLevels.1"), "id":SERVICE_DROPCONTROL_LITE},
        {"label":t("billing.serviceLevels.2"), "id":SERVICE_DROPCONTROL_DROPCONTROL},
        {"label":t("billing.serviceLevels.3"), "id":SERVICE_DROPCONTROL_PREMIUM},
    ];
    const billingPeriods = [
        {"label":t("billing.policyPage.periods."+CONTRATO_MENSUAL), "id":CONTRATO_MENSUAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_TRIMESTAL), "id":CONTRATO_TRIMESTAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_SEMESTRAL), "id":CONTRATO_SEMESTRAL},
        {"label":t("billing.policyPage.periods."+CONTRATO_ANUAL), "id":CONTRATO_ANUAL}];
    const monthString = t("forms.graphMeses").split("-");
    const billingMonths = {
        [CONTRATO_ANUAL]:[
            {"label":monthString[0], "id":1},
            {"label":monthString[1], "id":2},
            {"label":monthString[2], "id":3},
            {"label":monthString[3], "id":4},
            {"label":monthString[4], "id":5},
            {"label":monthString[5], "id":6},
            {"label":monthString[6], "id":7},
            {"label":monthString[7], "id":8},
            {"label":monthString[8], "id":9},
            {"label":monthString[9], "id":10},
            {"label":monthString[10], "id":11},
            {"label":monthString[11], "id":12}],
        [CONTRATO_TRIMESTAL]:[
            {"label":`${monthString[0]}-${monthString[3]}-${monthString[6]}-${monthString[9]}`, "id":1},
            {"label":`${monthString[1]}-${monthString[4]}-${monthString[7]}-${monthString[10]}`, "id":2},
            {"label":`${monthString[2]}-${monthString[5]}-${monthString[8]}-${monthString[11]}`, "id":3}],
        [CONTRATO_SEMESTRAL]:[
            {"label":`${monthString[0]}-${monthString[6]}`, "id":1},
            {"label":`${monthString[1]}-${monthString[7]}`, "id":2},
            {"label":`${monthString[2]}-${monthString[8]}`, "id":3},
            {"label":`${monthString[3]}-${monthString[9]}`, "id":4},
            {"label":`${monthString[4]}-${monthString[10]}`, "id":5},
            {"label":`${monthString[5]}-${monthString[11]}`, "id":6}]
    };

    useEffect(() => {
        if(billingInfo?.nodos){
            let nodos = billingInfo.nodos?.filter(nd => nd.contrato != null);
            const dcService = billingInfo?.lista?.precios?.filter(s => s.servicio_id === SERVICE_DROPCONTROL)[0];
            let expertCount = 0;
            nodos = nodos.map(nd => {
                if(nd.contrato === "EXP-C1" || nd.contrato === "EXP-C1" || nd.contrato === "EXP-C1") {
                    expertCount = expertCount+1;
                }
                const valor = dcService?.config?.["DROPCONTROL"]?.[nd.contrato];
                return {...nd, value:valor};
            });
            const discount= billingInfo?.lista.config_descuentos?.filter(dcto => dcto.rangeMin >= expertCount && expertCount <= (dcto.rangeMax ?? Number.MAX_SAFE_INTEGER));
            const priceList = {...billingInfo?.lista, descuento:discount?.[0]};
            nodos = nodos.map(nd => {
                return {...nd, value:nd.value- ((nd.value*priceList?.descuento?.discount??0)/100).toFixed(2)};
            });
            setNodes(nodos);
            setPriceList(priceList);
        }
    },[]);
    const valueNodeTemplate = (rowData) => {
        return `${rowData.value} USD`;
    };
    const valueNodeTotalTemplate = (rowData, billingInfo) => {
        switch (billingInfo?.periodo) {
            case 2:
                return `${(rowData.value*3).toFixed(2)} USD`;
            case 3:
                return `${(rowData.value*12).toFixed(2)} USD`;
            case 4:
                return `${(rowData.value*6).toFixed(2)} USD`;

            default:
                return t("billing.policyPage.periods.null");
        }
    };
    return (
        <div className='row'>
            <div className="col-xl-12 col-lg-12 col-sm-12">
                <div id="cardRaw" className="card">
                    <div className="card-body">
                        <div className='row'>
                            <div className='col-xl-12 col-lg-12 col-sm-12 text-center'>
                                <h5 className="card-title"><span>{t("billing.billingparams")}</span></h5>
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className="row">
                            <div className="row linea-formulario col-12 text-center">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{t("billing.nCliente")}</label>
                                </div>
                                <div className="col-xl-8 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label>{billingInfo?.n_cliente_id>0?billingInfo?.n_cliente_id:""}</label>
                                </div>
                            </div>
                            <div className="row linea-formulario col-12 text-center">
                                <div className="col-xl-4 col-lg-12 col-sm-12  text-sm-left mtem-05">
                                    <label className="boldie">{t("billing.serviceLevel")}</label>
                                </div>
                                <div className="col-xl-8 col-lg-12 col-sm-12  text-sm-left mtem-05">
                                    <label>{serviceLevels.find(m => m.id === billingInfo?.ser_campo?.[0]?.config?.SERVICE)?.label}</label>
                                </div>
                            </div>
                            <div className="row linea-formulario col-12 text-center">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{t("billing.policyPage.billingPeriod")}</label>
                                </div>
                                <div className="col-xl-8 col-lg-12 col-sm-12  text-sm-left mtem-05">
                                    <label>{billingPeriods.find(m => m.id === billingInfo?.periodo)?.label}</label>
                                </div>
                            </div>
                            {
                                billingInfo?.periodo!==CONTRATO_MENSUAL?
                                    <div className="row linea-formulario col-12 text-center">
                                        <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                            <label className="boldie">{t("billing.billingMonth"+(billingInfo?.periodo===CONTRATO_ANUAL?"":"s"))}</label>
                                        </div>
                                        <div className="col-xl-8 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                            <label>{billingMonths?.[billingInfo?.periodo]?.find(m => m.id === billingInfo?.mes_facturacion)?.label}</label>
                                        </div>
                                    </div>
                                    :null
                            }
                            <div className="row linea-formulario col-12 text-center">
                                <div className="col-xl-4 col-lg-12 col-sm-12 text-sm-left mtem-05">
                                    <label className="boldie">{t("sass.integrador")}</label>
                                </div>
                                <div className="col-xl-8 col-lg-12 col-sm-12 text-sm-left mtem-05 mb-2">
                                    <label>{billingInfo?.nombre_integrador??t("billing.noIntegrator")}</label>
                                </div>
                            </div>

                            <div className="row linea-formulario col-12 text-left">
                                <div className="col-xl-4 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.policyPage.maxApi")}</label>
                                </div>
                                <div className="col-xl-3 col-lg-12 col-sm-12">
                                    <label>{priceList?.descuento?.includedAPI}</label>
                                </div>
                                <div className="col-xl-3 col-lg-12 col-sm-12">
                                    <label className="boldie text-left">{t("billing.policyPage.valueApi")}</label>
                                </div>
                                <div className="col-xl-2 col-lg-12 col-sm-12">
                                    <label>{`${(priceList?.precios.find(s => s.servicio_id === SERVICE_ADDITIONAL_API)?.config?.[billingInfo.es_cliente?"clientAPI":"farmAPI"])-(((priceList?.precios.find(s => s.servicio_id === SERVICE_ADDITIONAL_API)?.config?.[billingInfo.es_cliente?"clientAPI":"farmAPI"])*priceList?.descuento?.discount??0))/100} USD`}</label>
                                </div>
                            </div>
                            <div className="row linea-formulario col-12 text-left">
                                <div className="col-xl-4 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("billing.policyPage.maxUser")}</label>
                                </div>
                                <div className="col-xl-3 col-lg-12 col-sm-12">
                                    <label>{priceList?.descuento?.includedUser}</label>
                                </div>
                                <div className="col-xl-3 col-lg-12 col-sm-12">
                                    <label className="boldie text-left">{t("billing.policyPage.valueUser")}</label>
                                </div>
                                <div className="col-xl-2 col-lg-12 col-sm-125">
                                    <label>{`${(priceList?.precios.find(s => s.servicio_id === SERVICE_ADDITIONAL_USER)?.config?.[billingInfo.es_cliente?"clientUser":"farmUser"])-(((priceList?.precios.find(s => s.servicio_id === SERVICE_ADDITIONAL_USER)?.config?.[billingInfo.es_cliente?"clientUser":"farmUser"])*priceList?.descuento?.discount??0))/100} USD`}</label>
                                </div>
                            </div>
                            <div className="row linea-formulario col-12 text-left">
                                <div className="col-xl-12 col-lg-12 col-sm-12">
                                    <label className="boldie">{t("farms.nodesTable.title")}</label>
                                </div>
                                <div className="col-xl-12 col-lg-12 col-sm-12">

                                    <DataTablePrime
                                        t={t}
                                        dataKey="nodo_id"
                                        items={nodes}
                                        scrollHeight="55vh"
                                        paginator rows={10} rowsPerPageOptions={[10, 25, 50]}
                                        size="small"
                                        globalFilterFields={["razon_social", "nombre", "n_cliente_id"]}
                                        fields={[
                                            {field:"nombre",header:t("general.type"), bodyStyle:{textAlign:"center"}},
                                            {field:"contrato",header:t("billing.policyPage.nodesPlan"), bodyStyle:{textAlign:"center"}},
                                            {field:"value",header:t("billing.policyPage.monthValue"), body:valueNodeTemplate, bodyStyle:{textAlign:"center"}},
                                            {field:"total_periodo",header:t("billing.totalPeriod"), body:(e) => valueNodeTotalTemplate(e, billingInfo),  bodyStyle:{textAlign:"center"}},
                                        ]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default withName(BillingParamsPanel, "BillingParamsPanel");
